import enLocale from './en'
export default {
  ...enLocale,
  language: 'Язык',
  confirm: 'Подтвердить',
  go: 'Перейти',
  status: 'Статус',
  balance: 'Баланс',
  cash: 'Наличные',
  createNew: 'Создать',
  home: 'Главная',
  market: 'Рынок',
  markets: 'Рынки',
  portfolio: 'Портфель',
  license: 'Лицензия',
  withdraw: 'Вывести',
  auditChecking: 'Проверка',
  insufficientFunds: 'Недостаточно средств',
  buy: 'Купить',
  history: 'История',
  seeMore: 'Показать ещё',
  theme: 'Тема',
  network: 'Сеть',
  walletBalance: 'Баланс кошелька',
  collect: 'Получить',
  approve: 'Одобрить',
  ticket: 'Лицензия',
  category: 'Категория',
  sortBy: 'Сортировать',
  issue: 'Выпустить',
  detail: 'Подробнее',
  stakingType: 'Залог',
  stakingTypeInfo: 'Чтобы предотвратить злонамеренное подтверждение, застейкайте токены или текущий NFT.',
  subscriptionAmount: 'Сумма покупки',
  subscription: 'Подписка',
  subscribe: 'Купить',
  max: 'Макс',
  marketClosed: 'Рынок закрыт',
  deposit: 'Добавить',
  verifiedNFT: 'Проверить лицензию',
  select: 'Выбрать',
  selected: 'Выбрано',
  moreNFT: 'Получить больше лицензий',
  forecastEvent: 'Событие',
  subscribeEndDate: 'Последнее время торговли',
  specifyExpiryDate: 'Указать время истечения',
  endDate: 'Время окончания',
  validityPeriod: 'Время истечения',
  marketEndDate: 'Время истечения',
  liquidityMin: 'Мин. ликвидность',
  premiumMin: 'Мин. премия',
  paymentCurrency: 'Валюта оплаты',
  defaultOdds: 'Базовое плечо',
  setDefaultOdds: 'Задать плечо',
  minInvestAmout: 'Мин. сумма инвестиций',
  depositMargin: 'Добавить ликвидность',
  totalPayment: 'Итого к оплате',
  rewards: 'Награды',
  rewardRate: 'Ставка наград',
  release: 'Разблокировать',
  fee: 'Комиссия',
  marginFeeRate: 'Ставка комиссии',
  cdsInfoOne: 'Для выпуска продукта застейкайте маржу, задайте плечо и минимум инвестиций.',
  cdsInfoTwo: 'Неучаствующая маржа может быть снята в любой момент.',
  cdsInfoThree: 'Если более одного участника подает апелляцию, запускается механизм управления.',
  deposited: 'Инвестировано',
  issued: 'Выпущено',
  depositedCDS: 'инвестированные продукты',
  totalProfit: 'Общий профит',
  allOrDeposited: 'Всего/Инвестировано',
  rewardsOrProfit: 'Награды/Профит',
  estimatedInvested: 'Оценка/Инвестировано',
  profit: 'Профит',
  yesterdayProfit: 'Профит за вчера',
  eventConfirming: 'Подтверждение события',
  appeal: 'Апелляция',
  appealing: 'Апелляция в процессе',
  appealFailed: 'Апелляция отклонена',
  occured: 'Произошло',
  notOccured: 'Не произошло',
  governanceMechanism: 'Голосование начинается при >1 апелляции.',
  appealLimit: 'Количество апелляций ≤ 1.',
  waitResult: 'Ожидание результата апелляции',
  frozenMargin: 'Замороженная маржа',
  marginBalance: 'Баланс маржи',
  endTime: 'Обратный отсчет',
  guaranteeing: 'В процессе',
  guaranteeingEvent: 'Прогноз в процессе',
  confirmsEventAdvance: 'Подтверждено досрочно',
  waitConfirmation: 'Ожидание подтверждения',
  triggerEvent: 'Подтверждено, событие произошло',
  notTriggerEvent: 'Событие не произошло',
  defaultChallenging: 'Произошло — оспаривание',
  notDefaultChallenging: 'Не произошло — оспаривание',
  defaultChallengeFailed: 'Произошло — оспаривание неудачно',
  notDefaultChallengeFailed: 'Не произошло — оспаривание неудачно',
  defaultWaitingResult: 'Произошло — ожидание управления',
  notDefaultWaitingResult: 'Не произошло — ожидание управления',
  defaultGovernanceMechanism: 'Произошло — управление подтвердило',
  notDefaultGovernanceMechanism: 'Не произошло — управление подтвердило',
  cancel: 'Отменить',
  defaultAhead: 'Досрочно',
  occur: 'Произошло',
  notOccur: 'Не произошло',
  stakingToChallenge: 'Стейкинг для оспаривания',
  challenged: 'Оспаривается',
  checking: 'Проверка',
  fail: 'Ошибка',
  appealInfoOne: 'Если решение неверно, «Оспорьте» и запустите механизм управления.',
  check: 'Проверить',
  contentIllegal: 'Содержит запрещенный контент. Измените и повторно опубликуйте.',
  subscribed: 'Инвестированные продукты',
  receivingCompensation: 'В ожидании',
  received: 'Итого выплата',
  receive: 'Получить',
  compensationAmount: 'Сумма компенсации',
  liquidity: 'Ликвидность',
  injectLiquidity: 'Влить ликвидность',
  uRLContent: 'URL/Содержание',
  resolutionSource: 'Источник решения',
  textareaInfo: 'Кратко опишите событие.',
  share: 'Поделиться',
  USDT: 'USDT',
  donations: 'Пожертвования',
  issueMsgPleaseSelectLicense: 'Пожалуйста, выберите лицензию',
  issueMsgLicenseCannotBeStaked: 'Лицензию нельзя застейкать',
  issueMsgNetworkNotConnected: 'Сеть не подключена',
  issueMsgEventEmpty: 'Событие пусто',
  issueMsgSelectLicense: 'Выберите лицензию',
  issueMsgLastTradingDateEmpty: 'Последнее время торговли пусто',
  issueMsgExpirationDateEmpty: 'Время истечения пусто',
  issueMsgLastTradingDateGreaterThanToday: 'Последнее время торговли должно быть позже сегодняшнего дня',
  issueMsgLastTradingDateGreaterThanExpirationDate: 'Последнее время торговли позже времени истечения',
  issueMsgEventEndDateGreaterThanRentalEndDate: 'Время окончания события {eventEndDate} больше, чем время окончания аренды {rentalEndDate}',
  issueMsgOptionsEmpty: 'Опции не могут быть пустыми',
  issueMsgOptionsLessThanTwo: 'Нужно минимум две опции',
  issueMsgOptionEmpty: 'Содержимое опции пусто',
  issueMsgOptionRepeated: 'Содержимое дубл.',
  issueMsgLastTradingDateGreaterThanToday: 'Последний день позже сегодня',
  issueMsgLastTradingDateGreaterThanExpirationDate: 'Последний день позже истечения',
  issueMsgLicenseError: 'Ошибка лицензии',
  issueMsgTicketError: 'Ошибка билета',
  issueMsgEventEndDateGreaterThanRentalEndDate: 'Дата конца {eventEndDate} > конца аренды {rentalEndDate}',
  issueMsgInsufficientBalance: 'Недостаточно средств',
  issueMsgTransactionFailed: 'Транзакция не удалась',
  issueMsgIssueSuccess: 'Выпуск успешен',
  issueMsgTransactionCancelled: 'Транзакция отменена',
  short: {
    confirmsEventAdvance: 'Досрочно',
    waitConfirmation: 'Ожидает подтверждения',
    defaultChallenging: 'Произошло — оспаривание',
    notDefaultChallenging: 'Не произошло — оспаривание',
    defaultChallengeFailed: 'Произошло — оспаривание провалено',
    notDefaultChallengeFailed: 'Не произошло — оспаривание провалено',
    defaultWaitingResult: 'Произошло — управление',
    notDefaultWaitingResult: 'Не произошло — управление',
    defaultGovernanceMechanism: 'Произошло — подтверждено управлением',
    notDefaultGovernanceMechanism: 'Не произошло — подтверждено управлением'
  },
  wallet: {
    openWallet: 'Откройте кошелек',
    connectWallet: 'Подключить кошелек',
    connectingWallet: 'Подключение кошелька',
    connectYourWallet: 'Подключите кошелек',
    disconnect: 'Отключить',
    wrongNetwork: 'Неверная сеть'
  },
  NFT: {
    getPrediLicense: 'Получить лицензию Predi',
    referralRewards: 'Реферальные награды',
    mintYourLicence: 'Сминтить лицензию',
    usageRights: 'Права использования',
    issuePredictionProducts: 'Выпустить продукты',
    governance: 'Голосование',
    properties: 'Свойства',
    tradable: 'Торгуемый',
    rentable: 'Сдаваемый',
    usable: 'Используемый',
    marketsToIssue: 'Рынки для выпуска',
    times: 'Раз',
    availableTimes: 'Доступно раз',
    ticketId: 'ID билета',
    cancelRentHint: 'Лицензия в аренде, отмените, чтобы продать.',
    sell: 'Продать',
    rent: 'Аренда',
    share: 'Поделиться',
    USDT: 'USDT',
    common: 'Обычный',
    scarcity: 'Редкость',
    attributive: 'Атрибутивный',
    numbers: 'Количество выпусков',
    issueTip: 'Выпустить 10 рынков/лицензий',
    price: 'Цена',
    success: 'Успешно',
    getNFT: 'Лицензия получена',
    issueCDS: 'Выпустить рынки Predi',
    buyNow: 'Купить сейчас',
    mintNow: 'Сминтить сейчас',
    rule: 'Правила',
    comingSoon: 'Скоро!',
    type: 'Тип',
    from: 'От',
    to: 'К',
    me: 'Я',
    rented: 'В аренде',
    sold: 'Продано',
    tabGetLicense: 'Получить лицензию',
    tabMyLicense: 'Моя лицензия',
    bought: 'Куплено',
    boughtProducts: 'Купленные продукты',
    investedProducts: 'Инвестированные продукты',
    issuedProducts: 'Выпущенные продукты',
    positions: 'Позиции',
    options: 'Опции',
    all: 'Все',
    volume: 'Объем',
    newest: 'Новое',
    price: 'Цена',
    pending: 'Ожидается',
    audit: 'Проверка',
    loading: 'Загрузка',
    home: 'Главная',
    market: 'Рынок',
    markets: 'Рынки',
    portfolio: 'Портфель',
    license: 'Лицензия',
    empowering: 'Вдохновляя визионеров предсказывать будущее',
    myPositions: 'Мои позиции',
    challengeCredit: 'Кредит оспаривания',
    challengeStatus: 'Статус оспаривания',
    succeed: 'Успех',
    wait: 'Ожидание',
    return: 'Доход',
    createYourOwnMarket: 'Создать свой рынок',
    waitChallenge: 'Ожидание оспаривания.',
    waitingGovernanceResult: 'Ожидание результата управления.',
    eventFinished: 'Событие завершено.',
    cancelled: 'Отменено',
    predictionProduct: 'Продукт предсказания',
    complaintCountdown: 'Отсчет жалобы',
    setResult: 'Установить результат',
    challenge: 'Оспорить',
    recycleTicket: 'Вернуть билет',
    eventCancelled: 'Событие отменено.',
    auditChecking: 'Проверка',
    insufficientFunds: 'Недостаточно средств',
    buyTicket: 'Купить билет',
    buy: 'Купить',
    listYourToken: 'Листинг токена',
    setResultModalTitle: 'Установить результат:',
    cancelModalTitle: 'Отмена',
    cancelIrreversible: 'Отмена необратима.',
    challengeModalTitle: 'Оспаривание',
    challengeStakeIntro: 'Если факт неверен, средства будут возвращены.',
    challengeStakeButton: 'PRDS для оспаривания',
    history: 'История',
    seeMore: 'Показать еще',
    licenses: 'Лицензии',
    prediLicense: 'Лицензия Predi',
    issuableQuantity: 'Доступное количество',
    disabled: 'Отключено',
    battleImage: 'Изображение',
    upload: 'Загрузить',
    showSample: 'Показать пример',
    battleInformation: 'Информация',
    baseToken: 'Базовый токен',
    collateral: 'Залог',
    currentLicense: 'Текущая лицензия',
    predictionProject: 'Проект предсказания:',
    issueExpireIntro: 'На истечении правильные делят токены.',
    issueParticipateUntil: 'Участие до',
    issueConfirmAdvance: 'При досрочном событии — досрочное подтверждение.',
    issueChallengeWithin7Days: 'Оспаривание в течение 7 дней.',
    issueAttention: 'Predi — развлечения и социал. Азартные игры запрещены.',
    eventSampleTitle: 'Событие',
    issueSampleCrypto: '[Крипто] Диапазон цены BTC на конец 2025?',
    issueSampleFinance: '[Финансы] Решение ставки ФРС США в Q3 2025?',
    issueSampleTechnology: '[Технологии] Какая компания запустит первого автономного робота-ассистента на ИИ?',
    issueSampleSports: '[Спорт] Кто выиграет ЧМ-2026?',
    issueSampleSociety: '[Соц] Какая платформа будет иметь больше всего MAU в 2025?',
    issueSampleOthers: '[Другое] Когда закончится война Россия—Украина?',
    issuerResult: 'Результат эмитента',
    daoResult: 'Результат DAO',
    predictionToken: 'Токен предсказания',
    issuer: 'Эмитент',
    issuerProfit: 'Профит эмитента'
  },
  claim: {
    title: 'Получите PRDs бесплатно',
    subtitle: 'Получите токены PRDs кликом',
    walletAddress: 'Адрес кошелька',
    status: 'Статус',
    connectWalletFirst: 'Сначала подключите кошелек',
    eligibility: {
      claimed: 'Уже получено',
      eligible: 'Можно получить',
      error: 'Ошибка проверки'
    },
    button: {
      claim: 'Получить',
      alreadyClaimed: 'Уже получено',
      connect: 'Подключить'
    },
    footerNotice: 'Кошелек может получить один раз. Проверьте сеть.',
    messages: {
      connectFirst: 'Подключите кошелек сначала',
      claimSuccess: 'Успешно!',
      claimFailed: 'Не удалось, попробуйте позже',
      txCancelled: 'Транзакция отменена',
      onlyOnce: 'Пользователь может один раз',
      insufficientBalance: 'Недостаточно средств в контракте, позже'
    }
  },
  
  // Additional top-level keys from en.js
  inputSearchText: 'Пожалуйста введите поисковый запрос',
  predictionProduct: 'Продукт предсказания',
  listYourToken: 'Листинг токена',
  description: 'Описание',
  positions: 'Позиции',
  options: 'Опции',
  all: 'Все',
  volume: 'Объем',
  newest: 'Новое',
  pending: 'Ожидается',
  audit: 'Проверка',
  loading: 'Загрузка',
  challengeCredit: 'Кредит оспаривания',
  challengeStatus: 'Статус оспаривания',
  succeed: 'Успех',
  wait: 'Ожидание',
  return: 'Доход',
  waitChallenge: 'Ожидание оспаривания.',
  complaintCountdown: 'Отсчет жалобы',
  setResult: 'Установить результат',
  issueParticipateUntil: 'Участие до',
  specifyLastTradingDate: 'Указать последнее время торговли',
  empowering: 'Вдохновляя визионеров предсказывать будущее',
  amount: 'Сумма',
  createYourOwnMarket: 'Создать свой рынок'
}